import PropTypes from 'prop-types';

import Title from './Title';
import Description from './Description';
import SvgSomethingWentWrong from 'assets/svg/something-went-wrong.svg';

export default function SomethingWentWrong({ title, description }) {
  return (
    <>
      <img src={SvgSomethingWentWrong} style={{ height: '40%' }} />
      {title && <Title>{title}</Title>}
      {description && <Description>{description}</Description>}
    </>
  );
}

SomethingWentWrong.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

SomethingWentWrong.defaultProps = {
  title: 'Something went wrong ?',
  description: 'Contact system administrator',
};
